import React, {useEffect, useRef, useState} from 'react';
import {Button, Flex, InputItem, List, TextareaItem, Toast, Checkbox} from 'antd-mobile';
import {createForm} from 'rc-form';
import {find, isArray, keyBy, mapValues, includes, keys, filter} from 'lodash';
import {SinglePicker} from "./SinglePicker";

const {CheckboxItem} = Checkbox;


// todo
//  expand supported field types (as needed...)

// interogates decorator rules
const isRequired = (dec={})=>{
  return  isArray(dec.rules) && find(dec.rules, { 'required': true });
};

// Wrapped CheckboxItem as they dorked it up
const CheckboxItemWrapper = ({value, ...props})=>{
    return <CheckboxItem checked={value} {...props}/>
};


const BasicForm = ({
    headerText='', buttonSize, labelNumber=5,
    allowSubmitNoTouch=false, allowSubmitWithErrors=false,
    showReset=false, showClear=false,
    onSubmit, onCancel, onError,
    submitText='Done', resetText='Reset', cancelText='Cancel', clearText='Clear',
    isVisible, submitNotVisible=false,
    fields=[], form, ...props}) => {

    const [pickers, setPickers] = useState({});

    const localChange = (value, field) =>{
        console.log('changed: '+value);

        const depFields = filter(fields,{dataDep:field.id});
        if (depFields.length){
            const clear = {};
            setPickers(p=>{
                depFields.forEach(depF=>{
                    if (p[depF.id].dataFn) {
                        p[depF.id].data = p[depF.id].dataFn(value);
                        clear[depF.id] = '';
                    }
                });
                return {...p};  // repacakge to trigger change
            });
            setFieldsValue(clear);
        }
    };

    useEffect(()=>{
        /*const dependentPickers = find(fields,f=>f.type==='Picker' && f.dataFn)||[];
        const picks = {}
        dependentPickers.forEach(p=>{
            picks[p.id] = p;
        });
        setPickers(dependentPickers);
         */
        //todo this gets all fields...
        setPickers(keyBy(fields,'id'));
    },[fields]);

    //Note: props.form comes from HOC instantiation;
    const {getFieldProps, resetFields, isFieldsTouched,
        validateFields, getFieldsError, getFieldError,
        setFieldsValue
    } = form;

    const hasErrors = (fieldsError={}) => {
        return Object.keys(fieldsError).some(field => fieldsError[field]);
    };

    const hsRef = useRef((e) => {
        if (e) {
            e.preventDefault();
        }
        validateFields((err, values) => {
            //console.dir(values);
            if (err && onError) {
                onError(err, values);
            }
            else if (!err && onSubmit) {
                //console.log('Parent Submit!');
                onSubmit(values);
            }
        });
    }); //NOTE:  Will only use initial onError,  onSubmit & validateFields
        // - but these should not change (TBD)

    const handleSubmit = hsRef.current;  // set everytime but to same value

    useEffect(()=>{
        //console.log('Submit? vis:'+isVisible);
        if (isVisible===false && submitNotVisible) {
            //console.log('Force Submit!');
            handleSubmit();
        }
    },[isVisible, submitNotVisible, handleSubmit]);

    const displayErrors = (fieldId) => {
        let errors = getFieldError(fieldId);
        if (errors) {
            Toast.info(errors.join(','));
        }
    };

    // todo inspect field type and/or support onClear prop
    const clearFields = ()=>{
        setFieldsValue(mapValues(keyBy(fields, 'id'), ()=>''));
    };

    return (
            <List
                renderHeader={() => headerText}
                className={'mm-form'}
                {...props}>

                {fields.map((f)=> {

                    const fieldProps = {
                        ...getFieldProps(f.id, f.decorator),
                        key : f.id,
                        labelNumber,
                        error: getFieldError(f.id),
                        onErrorClick: ()=> displayErrors(f.id)
                    };
                    // tap into onChange chain
                    const formOnChange = fieldProps.onChange;
                    fieldProps.onChange = value=>{
                        formOnChange(value);
                        localChange(value, f);
                    };

                    if (f.type === 'TextareaItem') {
                        if (f.rows === 0) {
                            fieldProps.autoHeight = true;
                        } else {
                            fieldProps.rows = f.rows || 4;
                        }
                    } else if (f.type==='ChecboxItem') {
                        // ?
                    } else if (f.type) {
                        fieldProps.type = f.type; // HTML type to trigger keyboard?
                    }

                    const label = <span className={'mm-label'}>{f.label}{isRequired(f.decorator)
                        ? <span style={{color: 'red'}}>*</span> : ''}</span>;

                    return f.type === 'TextareaItem'
                        ? (<TextareaItem
                            {...fieldProps}
                            title={label}
                        />)
                        : f.type === 'Picker'
                        ? <SinglePicker
                                data={(pickers[f.id]||{}).data}
                                valueDisplay={f.valueDisplay}
                                label={label}
                                {...fieldProps}
                            />
                        : f.type === 'CheckboxItem'
                        ? <CheckboxItemWrapper
                              {...fieldProps}
                        >{label}</CheckboxItemWrapper>
                        : <InputItem
                            {...fieldProps}
                        >{label}</InputItem>
                })}

                <List.Item

                >
                    <Flex >
                        {onCancel &&
                            <Flex.Item>
                                <Button
                                    size={buttonSize}
                                    onClick={onCancel}
                                >{cancelText}
                                </Button>
                            </Flex.Item>}
                        {showClear &&
                        <Flex.Item>
                            <Button
                                size={buttonSize}
                                onClick={()=>clearFields()}
                            >{clearText}
                            </Button>
                        </Flex.Item>}
                        {showReset &&
                        <Flex.Item>
                            <Button
                                size={buttonSize}
                                onClick={()=>resetFields()}
                                disabled={!isFieldsTouched()}
                            >{resetText}
                            </Button>
                        </Flex.Item>}
                        <Flex.Item>
                            <Button
                            size={buttonSize}
                            type="primary"
                            htmltype="submit"
                            disabled={
                                ( !allowSubmitWithErrors && hasErrors(getFieldsError()) ) ||
                                !( allowSubmitNoTouch || isFieldsTouched() )}
                            onClick={handleSubmit}
                        >{submitText}
                            </Button>
                        </Flex.Item>
                    </Flex>
                </List.Item>

            </List>
    );
};


const Form =  createForm({
        onFieldsChange(_, changedFields, allFields) {
            console.log('onFieldsChange: ', changedFields, allFields);
        },
        onValuesChange(_, changedValues, allValues) {
            console.log('onValuesChange: ', changedValues, allValues);

            if ( includes(keys(changedValues,'category'))) {

            }
        }
    }
)(BasicForm);
export {Form};